import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useOutlet } from 'react-router-dom';

const ExploreRoot: React.FC = () => {
  const outlet = useOutlet();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (outlet) {
      return;
    }

    navigate('/overview' + location.search, { replace: true });
  }, [outlet, navigate, location.search]);

  return <Outlet />;
};

export default ExploreRoot;
